import React, { useContext } from 'react'
import { BlogContext, BlogProvider } from './BlogContext'
import HTag from '@/lib/HTag'
import CTA from '@/lib/CTA'
import BlogList from './BlogList'

const App = ({ heading, cta }) => {
	const { posts } = useContext(BlogContext)

	return (
		<section className="section">
			<header className="text-center mb-8">
				<HTag className="h1" {...heading} />
				<p className="mt-8"><CTA {...cta} /></p>
			</header>

			<BlogList posts={posts.slice(0,4)} />
		</section>
	)
}

const BlogCarousel = props => <BlogProvider children={<App {...props} />} />

export default BlogCarousel
